import { render, staticRenderFns } from "./header1.vue?vue&type=template&id=28ad73a6&scoped=true"
import script from "./header1.vue?vue&type=script&lang=js"
export * from "./header1.vue?vue&type=script&lang=js"
import style0 from "./header1.vue?vue&type=style&index=0&id=28ad73a6&prod&lang=less"
import style1 from "./header1.vue?vue&type=style&index=1&id=28ad73a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad73a6",
  null
  
)

export default component.exports